/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Pipe({
    name: 'percent',
    standalone: false,
})
export class PercentPipe implements PipeTransform {
    transform(value: any): string {
        if (_.isNumber(value)) {
            return `${_.round(100 * value, 0)} %`;
        }
        return '';
    }
}
